import styled from "@emotion/styled";
import { LoadingButton } from "@mui/lab";
import { ButtonAProps } from "@src/ruix/types";

const ButtonA = (props: ButtonAProps) => {
	const { buttonClass, ...rest } = props;

	const getVariant = (buttonClass: string) => {
		switch (buttonClass) {
			case "gray-blue":
				return "contained";
			case "black":
				return "contained";
			case "text":
				return "text";
			case "white":
				return "contained";
			case "outlined-white":
				return "outlined";
			case "outlined-primary":
				return "outlined";
			case "primary":
				return "contained";
			case "secondary":
				return "contained";
			case "disable":
				return "outlined";
			default:
				return "outlined";
		}
	};

	return (
		<ButtonAComponent
			className={buttonClass}
			{...rest}
			variant={getVariant(buttonClass)}
		></ButtonAComponent>
	);
};

const ButtonAComponent = styled(LoadingButton)`
	border-radius: 6px;
	font-weight: bold;

	&.primary {
		&:hover {
			background-color: var(--primary-darken);
		}
	}

	&.black {
		background-color: #1c1c1c;
		color: white;
		border-color: none;
		&:hover {
			background-color: var(--bg);
		}
	}

	&.gray-blue {
		background-color: var(--gray-blue);
		color: white;
		border-color: none;
		&:hover {
			background-color: var(--gray-blue);
		}
	}

	&.white {
		background-color: white;
		color: black;
		border-color: none;
		&:hover {
			background-color: var(--white-darken);
		}
	}

	&.outlined-white {
		color: var(--card-bg);
		border-color: var(--bg-white);

		&:hover {
			background-color: var(--white-darken);
		}
	}

	&.outlined-primary {
	}

	&.disable {
		background-color: var(--gray-darken);
		color: var(--bg-white);
		border: none;
	}
`;

export default ButtonA;
